export default __webpack_public_path__ + "static/media/033-rice.0aede03f.svg";